var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Permission, Spinner, compose, graphql, isSufficientPermission, useAnalytics, withFeatureFlag, } from "@atlassiansox/microscopekit";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom"; // tslint:disable-line
import { PanelHeader } from "./panel-header";
import panelQuery from "./panel-info.query.graphql";
import serviceQuery from "./service-info.query.graphql";
import styled from "styled-components"; // tslint:disable-line
import { useKeyPress, useLocalDevToggle, useMicrosEnvironment } from "./hooks";
import { PanelContent } from "./panel-content";
import { ERROR_MESSAGES, cleanMicrosDeploymentInfo, isChromeless, withPanelsMigrationBanner, } from "./utils";
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  ", "\n\n  .header {\n    padding: 10px;\n    padding-left: 20px;\n    padding-right: 20px;\n    border-bottom: 1px solid #f4f5f7;\n  }\n\n  .content {\n    flex: 1;\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  ",
    "\n\n  .header {\n    padding: 10px;\n    padding-left: 20px;\n    padding-right: 20px;\n    border-bottom: 1px solid #f4f5f7;\n  }\n\n  .content {\n    flex: 1;\n    width: 100%;\n    height: 100%;\n  }\n"])), function (_a) {
    var fullWidth = _a.fullWidth;
    return fullWidth &&
        "\n  position:fixed\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1000;\n  background: #ffffff;";
});
export var PanelPageView = function (props) {
    var _a, _b, _c, _d, _e;
    var _f = props.match.params, id = _f.id, panelId = _f.panelId;
    var service = props.service, panel = props.panel;
    var _g = useLocalDevToggle(props.location.search, props.history, service, panel), localDev = _g.localDev, toggleDev = _g.toggleDev;
    var microsEnvironments = ((_a = service.service) === null || _a === void 0 ? void 0 : _a.microsV2) ? cleanMicrosDeploymentInfo((_b = service.service) === null || _b === void 0 ? void 0 : _b.microsV2)
        : [];
    var activeEnvironments = microsEnvironments.filter(function (e) { var _a; return (_a = e.stacks) === null || _a === void 0 ? void 0 : _a.stable; });
    var _h = useMicrosEnvironment(activeEnvironments, props.location.search, props.history), currentEnv = _h.currentEnv, setCurrentEnv = _h.setCurrentEnv;
    var _j = useState("" + Date.now()), time = _j[0], setTime = _j[1];
    var _k = useState(isChromeless()), isFullScreen = _k[0], setIsFullScreen = _k[1];
    var toggleFullScreen = function () {
        setIsFullScreen(function (v) { return !v; });
    };
    useKeyPress("Escape", function () {
        setIsFullScreen(function () { return false; });
    });
    var track = useAnalytics();
    useEffect(function () {
        if (service === null || service === void 0 ? void 0 : service.error) {
            track("PanelPlugin: ServiceInfoLoadFailed", { category: "error" });
        }
        if (panel === null || panel === void 0 ? void 0 : panel.error) {
            track("PanelPlugin: PanelInfoLoadFailed", { category: "error" });
        }
    }, [service, panel, track]);
    var isLoading = !props.service ||
        !props.panel ||
        props.service.loading ||
        props.panel.loading;
    if (isLoading) {
        return React.createElement(Spinner, null);
    }
    if (props.service.error) {
        return ERROR_MESSAGES.SERVICE_LOAD_ERROR(id);
    }
    if (props.panel.error) {
        return ERROR_MESSAGES.PANEL_LOAD_ERROR(panelId);
    }
    if (!props.service.service) {
        return ERROR_MESSAGES.SERVICE_NOT_FOUND(id);
    }
    if (!((_c = props.panel.panel) === null || _c === void 0 ? void 0 : _c.service)) {
        return ERROR_MESSAGES.PANEL_NOT_FOUND(panelId);
    }
    var serviceData = props.service.service;
    var panelData = (_e = (_d = props.panel) === null || _d === void 0 ? void 0 : _d.panel) === null || _e === void 0 ? void 0 : _e.service;
    var allPanelNames = serviceData.panels.map(function (p) { return p.name; });
    var userPanelNames = serviceData.panels
        .filter(function (p) {
        return isSufficientPermission(p.currentUserPermission, Permission.Write);
    })
        .map(function (p) { return p.name; });
    if (!allPanelNames.includes(panelId)) {
        return ERROR_MESSAGES.PANEL_NOT_INSTALLED(id, panelId);
    }
    if (!userPanelNames.includes(panelId)) {
        return ERROR_MESSAGES.NO_PANEL_PERMISSION(id, panelId, serviceData.metadata.ssamContainer.id);
    }
    if (!activeEnvironments.length) {
        return ERROR_MESSAGES.NO_ENVIRONMENTS(id);
    }
    var panelSource = localDev
        ? "local"
        : currentEnv.includes("prod")
            ? "prod"
            : "staging";
    return (React.createElement(Wrapper, { fullWidth: isFullScreen },
        React.createElement("div", { className: "header" },
            React.createElement(PanelHeader, { isFullScreen: isFullScreen, onToggleFullScreen: toggleFullScreen, service: serviceData, panel: panelData, onReloadPress: function () {
                    setTime("" + Date.now());
                }, onEnvChange: setCurrentEnv, currentEnvironment: currentEnv, environments: activeEnvironments, localDevMode: localDev, toggleLocalDevMode: toggleDev })),
        React.createElement("div", { className: "content" },
            React.createElement(PanelContent, { key: time + currentEnv, env: currentEnv, service: props.service.service, panel: props.panel.panel.service, name: panelId, deploymentSource: panelSource }))));
};
export var PanelPage = compose(withFeatureFlag("panelsPlugin"), withRouter, withPanelsMigrationBanner, graphql(serviceQuery, {
    name: "service",
    options: function (props) { return ({
        errorPolicy: "all",
        variables: {
            id: props.match.params.id,
        },
    }); },
}), graphql(panelQuery, {
    name: "panel",
    options: function (props) { return ({
        errorPolicy: "all",
        variables: {
            id: props.match.params.panelId,
        },
    }); },
}))(PanelPageView);
var templateObject_1;
